// extracted by mini-css-extract-plugin
export default {"status":"TableOrder_status__xtesm","seenInfo":"TableOrder_seenInfo__jNJzc","red":"TableOrder_red__uJG0x","green":"TableOrder_green__QeLVd","orange":"TableOrder_orange__BF40j"};